import styled from "styled-components";

import * as Table from "ds/Table";

export const Container = styled.div``;
export const Tr = styled(Table.Tr)`
  height: fit-content;
  box-shadow: none;

  :hover {
    box-shadow: none;
    background-color: var(
      --section-color-primary-100-background-color,
      var(--color-primary-100)
    );
  }
`;

export const Progress = styled.div`
  position: relative;
  height: 32px;
  width: 100%;
  line-height: 0;

  border-radius: 5px;

  background-color: var(--theme-neutral-100);

  overflow: hidden;
`;

export const ProgressBar = styled.div<{
  zIndex: number;
  width: number;
  color: string;
}>`
  position: absolute;
  height: 32px;
  margin: 0;
  padding: 0;

  z-index: ${props => props.zIndex ?? 2};
  background-color: ${props => props.color};
  width: ${props => props.width}%;
`;
